import { createSelector } from 'reselect'
import { ILocalSettingsRecord } from './interface'

const baseState = (state: any): ILocalSettingsRecord => state.get('persist').localSettings

export const isTopNotificationBlockShown = createSelector(baseState, state => state.get('isTopNotificationBlockShown'))

export const isPushEnabled = createSelector(baseState, state => state.get('isPushEnabled'))

export const isOptedOut = createSelector(baseState, state => state.get('isOptedOut'))

export const isNotificationsBlocked = createSelector(baseState, state => state.get('isNotificationsBlocked'))

export const isPending = createSelector(baseState, state => state.get('isPending'))

export const isOneSignalInitialized = createSelector(baseState, state => state.get('isOneSignalInitialized'))

export const isShowConfirmationModalForSwitchProTrack = createSelector(baseState, state =>
  state.get('isShowConfirmationModalForSwitchProTrack')
)

export const isShowConfirmationModalForStopProTrack = createSelector(baseState, state =>
  state.get('isShowConfirmationModalForStopProTrack')
)

export const isShowConfirmationModalForDifferentProTrack = createSelector(baseState, state =>
  state.get('isShowConfirmationModalForDifferentProTrack')
)

export const isShowConfirmationModalForCommitPreviousActivity = createSelector(baseState, state =>
  state.get('isShowConfirmationModalForCommitPreviousActivity')
)

export const isShowLoginInformationModal = createSelector(baseState, state => state.get('isShowLoginInformationModal'))

export const getLoadedLanguages = createSelector(baseState, state => state.get('loadedLanguages'))

export const getGlobalCountriesCodes = createSelector(baseState, state => state.get('countriesCodes'))

export const getQueries = createSelector(baseState, state => state.get('queries'))

const getBreadcrumbs = createSelector(baseState, state => state.get('breadcrumbs'))

export const getPreviousPathname = createSelector(getBreadcrumbs, bcs => {
  return bcs.get(bcs.size - 2)
})

export const isShouldAutoPlayVideo = createSelector(baseState, state => state.get('isShouldAutoPlayVideo'))
